import React from 'react';
import withLabelAndMeta from './withLabelandMeta';
import WeekPicker from '../WeekPicker';

const WeekPickerForForm = ({
  setFieldValue,
  field, // { name, value, onChange, onBlur }
  fieldDefinition,
  values,
}) => (
  <WeekPicker
    mt={1}
    id={fieldDefinition.key}
    startDate={field.value.start}
    onChange={(...args) => setFieldValue(field.name, ...args)}
    disabled={values.copyFrom !== 0}
  />
);

export default withLabelAndMeta(WeekPickerForForm);
